import { mutationFor } from "@visioni/a3s-client-api/app";
import { setNotificationPreferenceCategoryEndpoint, setContactPhoneNumberEndpoint } from "../client-messages";

/**
 * React Query mutation factory for replacing one scope+category's channel
 * preferences. Usage: `setNotificationPreferenceCategoryMutation(apiConfig, {})`.
 */
export const setNotificationPreferenceCategoryMutation = mutationFor(setNotificationPreferenceCategoryEndpoint);

/**
 * React Query mutation factory for replacing (or clearing, with `null`) the
 * calling user's contact phone number. Usage: `setContactPhoneNumberMutation(apiConfig, {})`.
 */
export const setContactPhoneNumberMutation = mutationFor(setContactPhoneNumberEndpoint);
